<template>
  <a-modal :visible="visible" okText="开始删除" :width="600" @ok="handleCreate" cancellText="取消" @cancel="visible = false"
    title="删除僵尸粉">
    <a-alert :style="{ marginBottom: '15px' }" message="每次删除操作建议不要超过总好友数量的15%,误操作引起的账号问题，与平台无关"></a-alert>
    <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-form-item label="删除好友时间间隔" :wrapperCol="wrapperCol">
        <a-input-number :min="0" :formatter="value => `${value}秒`"
          v-decorator="['min_time', { initialValue: 15, rules: [{ required: true, message: '必填项' }] }]">
        </a-input-number>
        -
        <a-input-number :min="0" :formatter="value => `${value}秒`"
          v-decorator="['max_time', { initialValue: 30, rules: [{ required: true, message: '必填项' }] }]">
        </a-input-number>
      </a-form-item>
      <a-form-item label="本次删除人数">
        <a-input-number :min="0" v-decorator="['num', { initialValue: 1, rules: [{ required: true, message: '必填项' }] }]" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      currentRobotId: 0,
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 12
      },
      badge: [
        '[昵称]'
      ]
    }
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
    show(currentRobotId) {
      this.visible = true
      this.currentRobotId = currentRobotId
      // console.log('currentRobotId=', currentRobotId)
    },
    copyText(text) {
      this.$copyText(text)
      this.$message.success('复制成功')
    },
    handleCreate() {
      this.form.validateFields((err, values) => {
        // console.log('values=', values)
        this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
          robotid: this.currentRobotId,
          type: 'die_fans_del',
          data: values
        }).then(result => {
          this.$message.success('发送指令成功')
          this.visible = false
        })
      })
    }
  }
}
</script>